/**
 * Cart Shipping Protection Toggle
 * Adds/removes a "Shipping Protection" product ($1.99) from the cart.
 *
 * ARCHITECTURE: Uses event delegation on document level so listeners
 * survive innerHTML replacements from Dawn's renderContents().
 */
(function () {
  var PRODUCT_HANDLE = 'shipping-protection-1';
  var productData = null;
  var busy = false;

  function fetchProductData(callback) {
    if (productData) return callback(productData);
    fetch('/products/' + PRODUCT_HANDLE + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Not found');
        return r.json();
      })
      .then(function (data) { productData = data; callback(data); })
      .catch(function () {
        // Product not found — hide all toggle instances
        document.querySelectorAll('.cart-shipping-protection').forEach(function (el) {
          el.style.display = 'none';
        });
      });
  }

  function addProtection() {
    if (busy) return;
    busy = true;
    fetchProductData(function (data) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: data.variants[0].id, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          busy = false;
          if (d.sections && window._updateCartDrawerSections) {
            window._updateCartDrawerSections(d.sections);
          } else {
            window.location.reload();
          }
        })
        .catch(function () { busy = false; window.location.reload(); });
    });
  }

  function removeProtection() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle === PRODUCT_HANDLE) { line = i + 1; break; }
        }
        if (!line) { busy = false; return; }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: line,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { if (r) return r.json(); })
      .then(function (d) {
        busy = false;
        if (d && d.sections && window._updateCartDrawerSections) {
          window._updateCartDrawerSections(d.sections);
        } else if (d) {
          window.location.reload();
        }
      })
      .catch(function () { busy = false; window.location.reload(); });
  }

  function isProtectionInCart() {
    // Check via cart API for reliability instead of DOM text matching
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var name = items[i].querySelector('.cart-item__name');
      if (name && name.textContent.trim() === 'Shipping Protection') return true;
    }
    return false;
  }

  function syncToggle() {
    var toggle = document.getElementById('CartDrawer-ShippingProtectionToggle');
    if (!toggle) return;
    toggle.checked = isProtectionInCart();
    toggle.disabled = false;
  }

  // Event delegation — survives innerHTML replacements
  document.addEventListener('change', function (event) {
    var toggle = event.target;
    if (!toggle.id || toggle.id !== 'CartDrawer-ShippingProtectionToggle') return;
    toggle.disabled = true;
    if (toggle.checked) { addProtection(); }
    else { removeProtection(); }
  });

  // Sync toggle state when cart drawer content is updated
  document.addEventListener('cart-drawer:rendered', syncToggle);

  // Sync when drawer opens (attribute change on cart-drawer element)
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var obs = new MutationObserver(function () {
      setTimeout(syncToggle, 100);
    });
    obs.observe(cartDrawer, { attributes: true });
  }

  // Initial sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncToggle);
  } else {
    syncToggle();
  }
})();
